import { Deserializable } from '../../protocols/deserializable';
import { LookAheadItem } from '../../../views/shared/components/search-with-look-ahead/look-ahead-list/look-ahead-item/protocol/look-ahead-item';

export class MemberUserSearchResult implements Deserializable, LookAheadItem {
  id: number;
  name: string;
  firstName: string;
  lastName: string;

  constructor(id: number = 0, name: string = '', firstName: string = '', lastName: string = '') {
    this.id = id;
    this.name = name;
    this.firstName = firstName;
    this.lastName = lastName;
  }

  onDeserialize() {}

  lookAheadDisplayValue(): string {
    return `${this.name} (${this.id})`;
  }

  lookAheadDisabled(): boolean {
    return false;
  }

  lookAheadDisabledMessage(): string {
    return '';
  }
}
